<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'WhatsappComponent.vue'
}
</script>

<style scoped></style>
